export default __webpack_public_path__ + "tmp_src/components/InstagramGallery/InstagramGallery~aurora.css.liquid";